import { baseApi } from "../api";

export interface PurchaseBannedResponse {
	success: boolean;
	value: boolean;
}

export const chargebackAPI = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		getPurchaseBanned: builder.query<PurchaseBannedResponse, string>({
			query: () => "/rest/user/purchase-banned"
		})
	})
});

export const { useGetPurchaseBannedQuery, useLazyGetPurchaseBannedQuery } =
	chargebackAPI;
